// Client for the Saved Insights API (Reservoir PHP, same-origin, session-cookie auth).
//
// Unlike catalystApi.js (cross-origin to the Catalyst gateway, bearer JWT), saved
// insights are Reservoir-native: these all hit the PHP API under window.config.API_URL
// with the session cookie (axios.defaults.withCredentials = true, set in index.js).
// See usalco_api/src/routes/ai_insights.php.

import axios from 'axios';

function apiUrl(path) {
  return window.config.API_URL + path;
}

// Save a single rendered result. `payload` = { toolName, result }.
export function saveResultInsight({ title, question, payload, reportGuid, chatId }) {
  return axios.post(apiUrl('ai/insights'), {
    kind: 'result', title, question, payload, reportGuid, chatId,
  }).then((r) => r.data);
}

// Save a whole conversation. `messages` = the chat's rich message array.
export function saveConversationInsight({ title, messages, reportGuid, chatId }) {
  return axios.post(apiUrl('ai/insights'), {
    kind: 'conversation', title, payload: { messages }, reportGuid, chatId,
  }).then((r) => r.data);
}

// Metadata list of my insights + those shared with me.
export function listInsights() {
  return axios.get(apiUrl('ai/insights')).then((r) => r.data?.data || []);
}

// One insight with its payload (access-checked server-side).
export function getInsight(guid) {
  return axios.get(apiUrl('ai/insights/' + encodeURIComponent(guid))).then((r) => r.data);
}

export function renameInsight(guid, title) {
  return axios.put(apiUrl('ai/insights/' + encodeURIComponent(guid)), { title }).then((r) => r.data);
}

export function deleteInsight(guid) {
  return axios.delete(apiUrl('ai/insights/' + encodeURIComponent(guid))).then((r) => r.data);
}

export function listShares(guid) {
  return axios.get(apiUrl('ai/insights/' + encodeURIComponent(guid) + '/shares')).then((r) => r.data?.data || []);
}

// grants: [{ principalType: 'user'|'role', principalId }]
export function addShares(guid, grants) {
  return axios.post(apiUrl('ai/insights/' + encodeURIComponent(guid) + '/shares'), { grants }).then((r) => r.data);
}

export function revokeShare(guid, shareGuid) {
  return axios.delete(
    apiUrl('ai/insights/' + encodeURIComponent(guid) + '/shares/' + encodeURIComponent(shareGuid)),
  ).then((r) => r.data);
}

export function listDirectoryUsers() {
  return axios.get(apiUrl('ai/insights/directory/users')).then((r) => r.data?.data || []);
}

export function listDirectoryRoles() {
  return axios.get(apiUrl('ai/insights/directory/roles')).then((r) => r.data?.data || []);
}
